import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Info } from "lucide-react";

interface MarketInfoItem {
  attribute: string;
  details: string;
}

interface MarketInfoCardProps {
  marketInfoItems: MarketInfoItem[];
}

export default function MarketInfoCard({
  marketInfoItems,
}: MarketInfoCardProps) {
  return (
    <Card className="shadow-lg border-slate-200 rounded-xl overflow-hidden h-full flex flex-col">
      <CardHeader className="pb-3 pt-5 px-6">
        <CardTitle className="text-2xl font-semibold text-slate-800 flex items-center gap-2">
          <Info size={20} className="text-indigo-600" />
          Market Information
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0 flex-grow">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-slate-300 bg-slate-100">
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500">Attribute</TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500">Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {marketInfoItems.map((item, index) => (
              <TableRow key={index} className="border-t border-slate-200 hover:bg-slate-50 transition-colors">
                <TableCell className="p-4 align-top text-base font-medium text-slate-700">{item.attribute}</TableCell>
                <TableCell className="p-4 align-top text-base text-slate-600">{item.details}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
